import React, { useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import {
  getFilterData,
  getPaginationOpts, getResponseError, responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import { getSystemData } from '../../System/reducer';
import Loader from '../../../components/base/Loader/Loader';
import { getNotificationData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import { AUTHORIZED_MODULE } from '../../../configs/moduleNames';
import { loadNotification, loadNotificationTypes, markAllNotification } from '../actions';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import {
  dateTimeFormatter,
  subjectFormatter,
  tooltipFormatter,
} from '../../../utils/formatters';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';
import TextInput from '../../../components/fields/TextInput/TextInput';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import NotificationDTO from '../../../dto/NotificationDTO';
import Grid from '../../../components/base/Grid/Grid';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import { NOTIFICATION_STATUS_MARK_LIST } from '../../../configs';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import NotificationPopUp from './NotificationPopUp';
import CustomSelectInputWithHelper from '../../../components/fields/SelectInput/CustomSelectInputWithHelper';

export default function NotificationPage() {
  const blockRef = useRef(null);
  const dispatch = useDispatch();
  const { updatePeriod } = useSelector(getSystemData);
  const pageName = 'notification';
  const filterName = `${pageName}-filter`;
  const store = useStore();
  const [showRollbackPlan, setShowRollbackPlan] = useState(false);
  const notificationColumns = [
    {
      dataField: 'created_at',
      text: 'Создание',
      formatter: date => dateTimeFormatter(date),
      headerClassName: 'notification-created-at-column',
    },
    {
      dataField: 'type_label',
      text: 'Тип уведомления',
      headerClassName: 'notification-subject-type-column',
    },
    {
      dataField: 'message',
      text: 'Текст',
      formatter: (a, item) => (item?.subject?.executor_id === '00000000-0000-0000-0000-000000000000' ? tooltipFormatter('[Автоматизация] '.concat(a)) : tooltipFormatter(a)),
      headerClassName: 'notification-message-column',
    },
    // {
    //   dataField: 'subject',
    //   text: 'Объект',
    //   formatter: (_, item) => subjectFormatter(item),
    //   headerClassName: 'notification-subject-column',
    // },
    {
      dataField: 'read_at',
      text: 'Прочитано',
      formatter: date => dateTimeFormatter(date),
      headerClassName: 'notification-read-at-column',
    },
  ];

  const defaultDate = getDefaultDataRange();
  const defaultFilterValues = {
    created_at_from: defaultDate[0],
    created_at_to: defaultDate[1],
  };

  const {
    notificationMeta,
    notification,
    loadingNotification,
  } = useSelector(getNotificationData);

  const [selected, setSelected] = React.useState(false);

  const DTO = new NotificationDTO();
  const attributes = DTO.getAttributesByName();

  const {
    getValues, control, watch, setValue, reset,
  } = useForm({ defaultValues: getFilterData(filterName, defaultFilterValues) });

  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(store.getState()[AUTHORIZED_MODULE].notificationMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: { ...filterData },
    };
    const p1 = dispatch(loadNotification(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const handleIsMarkAll = () => {
    dispatch(markAllNotification()).then(() => {
      successNotification('Уведомления', 'Все уведомления прочтены');
    }).catch(response => {
      errorNotification('Уведомления', getResponseError(response));
    });
  };

  const handleClose = () => {
    setSelected(false);
    setShowRollbackPlan(false);
  };

  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  useEffect(() => {
    const subscription = watch(values => {
      loadData({ page: 1 });
      localStorage.setItem(filterName, JSON.stringify(values));
    });
    return () => subscription.unsubscribe();
  }, [watch, filterName]);

  return (
    <div className="page notification-page">
      <Loader loading={loadingNotification} />
      <div className="page-title">
        <div className="title-text">Уведомления</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            className="no-border"
            inputBefore={(
              <div className="search-wrapper">
                <Icons customIcon className="search" width={24} height={24} icon="search" />
              </div>
              )}
          />
          <FieldDTO
            control={control}
            component={CustomSelectInputWithHelper}
            dtoObject={attributes.type}
            usePortal
            className="no-border"
            portalClassName="executor-selector"
            placeholder="Тип"
            loadAction={loadNotificationTypes}
            addPlaceholder
            optionFormatter={item => ({ value: item.value, name: item.label })}
            filterName="type"
          />
          <FieldDTO
            control={control}
            component={RangeDatePicker}
            dtoObject={attributes.created_at}
            usePortal
            placeholder="Дата подачи"
            changeFormat="YYYY-MM-DD"
            inputProps={{
              value: [getValues('created_at_from'), getValues('created_at_to')],
              onChange: e => {
                const v = e.target.value;
                setValue('created_at_from', v[0]);
                setValue('created_at_to', v[1]);
              },
            }}
            className="no-border"
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.only_unread}
            usePortal
            placeholder="Статус"
            className="no-border"
            options={NOTIFICATION_STATUS_MARK_LIST}
          />
          <div className="filter-sep" />
          <Button onClick={handleIsMarkAll}>Пометить прочитанными</Button>
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <Grid
                key={pageName}
                onClickByRow={() => {}}
                onDoubleClickByRow={item => setSelected(item)}
                data={notification}
                columns={notificationColumns}
                name={`${pageName}-list`}
              />
            </div>
          </div>
          <Pagination meta={notificationMeta} list={notification} handleChangeMeta={loadData} />
          { selected ? <NotificationPopUp onClose={() => setSelected(false)} setShowRollbackPlan={setShowRollbackPlan} current={selected} /> : null}
        </div>
      </div>
    </div>
  );
}
